import { render } from "./MandibleMaxillaryChart.vue?vue&type=template&id=7aee0b3b&scoped=true"
import script from "./MandibleMaxillaryChart.vue?vue&type=script&lang=js"
export * from "./MandibleMaxillaryChart.vue?vue&type=script&lang=js"

import "./MandibleMaxillaryChart.vue?vue&type=style&index=0&id=7aee0b3b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7aee0b3b"]])

export default __exports__